<!-- ROUTE -->
@if (isRoute()) {
  @let route = item().route;
  @let isActive = item().isActive;
  @let label = item().label;
  @let icon = item().icon;

  <div class="group py-1.5 relative">
    <a
      matRipple
      [matTooltip]="label | translate"
      [matTooltipPosition]="'right'"
      [matTooltipDisabled]="isSidebarExpanded()"
      class="sidebar-navigation-item flex items-center py-2 px-4 gap-3 rounded-sm transition-all duration-150 text-on-sidebar-navigation-item bg-sidebar-navigation-item group-hover:brightness-95 group-hover:dark:brightness-125"
      [routerLink]="route"
      [class.bg-sidebar-navigation-item-active]="isActive?.()"
      [class.text-on-sidebar-navigation-item-active]="isActive?.()"
      [title]="label | translate"
      [attr.data-active]="isActive?.()"
    >
      @if (icon && withIcon()) {
        <mat-icon
          class="shrink-0 group-hover:scale-105 transition-transform duration-150"
          [svgIcon]="icon"
        />
      }
      @if (isSidebarExpanded()) {
        <span
          [class.font-medium]="isActive?.()"
          class="truncate text-body-md tracking-body-md leading-body-md"
          animate.enter="appear"
          animate.leave="disappear"
        >
          {{ label | translate }}
        </span>
      }
      <!-- Live badge (e.g. due Wiedervorlagen): pill next to the label, mini-dot on the
           icon corner while collapsed — falsy counts render nothing -->
      @if (item().badge?.(); as badgeValue) {
        @if (isSidebarExpanded()) {
          <span class="ml-auto shrink-0 rounded-full bg-red-600 px-1.5 py-0.5 text-[10px] font-medium leading-none text-white">
            {{ badgeValue }}
          </span>
        } @else {
          <span class="absolute right-2 top-1 min-w-4 rounded-full bg-red-600 px-1 text-center text-[9px] font-medium leading-4 text-white">
            {{ badgeValue }}
          </span>
        }
      }
      @if (hasGroups() && isSidebarExpanded()) {
        <div class="shrink-0 size-4"></div>
      }
    </a>

    @if (hasGroups()) {
      <button
        [matTooltip]="`${isExpanded() ? 'Collapse' : 'Expand'} ${(label | translate)}`"
        [matTooltipPosition]="'right'"
        [matTooltipShowDelay]="300"
        [class.opacity-0]="!isSidebarExpanded()"
        [class.-right-3]="!isSidebarExpanded()"
        [class.right-2]="isSidebarExpanded()"
        class="hover:shadow-1 bg-sidebar text-on-sidebar absolute! top-1/2 transform -translate-y-1/2 group-hover:opacity-100 flex justify-center items-center cursor-pointer rounded-xs p-1 transition-opacity duration-300"
        matRipple
        (click)="isExpanded.set(!isExpanded())"
      >
        <mat-icon
          class="transition-transform duration-300 size-4!"
          [svgIcon]="ICON.caretDown"
          [class.rotate-180]="isExpanded()"
        />
      </button>
    }
  </div>
} @else if (isNoDestination()) {
  @let label = item().label;
  @let icon = item().icon;

  <div class="group py-1.5 relative">
    <button
      matRipple
      [matTooltip]="label | translate"
      [matTooltipPosition]="'right'"
      [matTooltipDisabled]="isSidebarExpanded()"
      class="flex items-center py-2 px-4 gap-3 rounded-sm w-full max-w-full transition-all duration-150 text-on-sidebar-navigation-item bg-sidebar-navigation-item group-hover:brightness-95 group-hover:dark:brightness-125"
      [title]="label | translate"
      (click)="isExpanded.set(!isExpanded())"
    >
      @if (icon && withIcon()) {
        <mat-icon
          class="shrink-0 group-hover:scale-105 transition-transform duration-150"
          [svgIcon]="icon"
        />
      }
      @if (isSidebarExpanded()) {
        <span
          class="truncate text-body-md tracking-body-md leading-body-md"
          animate.enter="appear"
          animate.leave="disappear"
        >
          {{ label | translate }}
        </span>
      }
      @if (hasGroups() && isSidebarExpanded()) {
        <div class="shrink-0 size-4"></div>
      }
    </button>

    @if (hasGroups()) {
      <button
        [matTooltip]="`${isExpanded() ? 'Collapse' : 'Expand'} ${(label | translate)}`"
        [matTooltipPosition]="'right'"
        [matTooltipShowDelay]="300"
        [class.opacity-0]="!isSidebarExpanded()"
        [class.-right-3]="!isSidebarExpanded()"
        [class.right-2]="isSidebarExpanded()"
        class="hover:shadow-1 bg-sidebar text-on-sidebar absolute! top-1/2 transform -translate-y-1/2 group-hover:opacity-100 flex justify-center items-center cursor-pointer rounded-xs p-1 transition-opacity duration-300"
        matRipple
        (click)="isExpanded.set(!isExpanded())"
      >
        <mat-icon
          class="transition-transform duration-300 size-4!"
          [svgIcon]="ICON.caretDown"
          [class.rotate-180]="isExpanded()"
        />
      </button>
    }
  </div>
}

<!-- CHILDREN -->
@if (isExpanded()) {
  @let children = item().children;

  <ol
    class="transition-all duration-300"
    [class.ml-2]="isSidebarExpanded()"
    animate.enter="expand-vertical"
    animate.leave="collapse-vertical"
  >
    @for (item of children; track item.id) {
      <li>
        <immo-navigation-item
          animate.enter="appear"
          animate.leave="disappear"
          [item]="item"
          [isExpanded]="isSidebarExpanded()"
        />
      </li>
    }
  </ol>
}
